export type PaywallVersion = 'v1' | 'v2';

export const usePaywallParams = () => {
  const route = useRoute();

  const getPaywallForce = () => {
    const paywallForce = route.query.paywall_force;
    if (paywallForce === false || paywallForce === 'false') return false;
    if (paywallForce !== undefined) return paywallForce === 'true' || paywallForce === true;
    return true;
  };

  const getPaywallClose = () => {
    const paywallClose = route.query.paywall_close;
    if (paywallClose !== undefined) {
      return paywallClose === 'true' || paywallClose === true;
    }
    return undefined;
  };

  const getPaywallVersion = (): PaywallVersion => {
    const version = route.query.paywall_version;
    if (version === 'v2') {
      return 'v2';
    }
    return 'v1';
  };

  const getFreeTrial = (): boolean => {
    const freeTrial = route.query.free_trial;
    if (freeTrial === undefined || freeTrial === null) return false;
    if (Array.isArray(freeTrial)) return freeTrial.some((v) => String(v).toLowerCase().trim() === 'true');
    return String(freeTrial).toLowerCase().trim() === 'true';
  };

  return {
    getPaywallForce,
    getPaywallClose,
    getPaywallVersion,
    getFreeTrial,
  };
};
